(function ($) {

  $("#keyword.search__field:empty").get(0).focus();

})(jQuery)